var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative border border-gray-300 overflow-hidden" },
    [
      _c("div", { staticClass: "relative ratio-2/3" }),
      _c(
        "div",
        { staticClass: "absolute inset-0 bg-gray-300" },
        [
          _c("BaseIcon", {
            staticClass:
              "absolute inset-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1/3 h-auto text-gray-500",
            attrs: { name: "photo" }
          }),
          _vm.title
            ? _c(
                "div",
                {
                  staticClass:
                    "\n                absolute inset-0 flex items-end justify-center p-4\n                text-sm text-center font-medium leading-relaxed\n            "
                },
                [_c("span", [_vm._v(_vm._s(_vm.title))])]
              )
            : _vm._e(),
          _vm.url
            ? _c("img", {
                staticClass: "absolute inset-0 w-full h-full",
                attrs: { src: _vm.url }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }